const binding = { modules: {}, dataActions: {} };

    (binding.modules['lyxxa'] = {
        c: () => require('partner/themes/ghab/ghab.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lyxxa',
        p: '__local__',
        
        pdp: 'src/themes/ghab/ghab.definition.json',
        
        themeSettings: 'lyxxa.theme.settings.json',
        md: 'src/themes/lyxxa'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };